export default __webpack_public_path__ + "static/3-a5ff61cbb38fc53509b7fb1cd8dc2126.png";